import Component from '@glimmer/component';

export default class TimePickerComponent extends Component {
  get timeSelections() {
    //generate time selections that start from 12 and go till 11:30 with 30 minute increments
    let timeSelections = [];
    for (let i = 0; i < 24; i++) {
      let hour = Math.floor(i / 2);
      if (hour === 0) hour = 12;
      let minute = i % 2 === 0 ? '00' : '30';
      let time = `${String(hour).padStart(2, '0')}:${minute}`;
      timeSelections.push({ label: time, value: time });
    }
    return timeSelections;
  }

  get ComponentName() {
    return this.args.tippy ? 'Tippy' : 'empty-component';
  }
}
